import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .email("Please enter a valid email.")
    .nullable()
    .required("Please enter a valid email"),
  studentId: Yup.string()
    .trim()
    .nullable()
    .required("Please enter a student ID")
    .matches(/^[0-9]+$/, "Student ID must only contain numbers")
    .min(9, "Must be exactly 9 digits")
    .max(9, "Must be exactly 9 digits"),
});

export const initialValues = {
  email: "",
  studentId: "",
};
